/**
 * Administration controller
 */

export default class {
  boot() {
    // Empty
  }
}
